import React from 'react';

import NodeCaoPage from './Page';

const NodeCao = ({ entity, className, viewMode }) => {
  switch (viewMode) {
    default:
      return (
        <NodeCaoPage className={className} entity={entity} />
      );
  }
};

export default NodeCao;
